<h3>{{ info() }}</h3>
<h1>{{ title() }}</h1>
<h2>{{ subtitle() }}</h2>
<div class="pixel-popup">
    <div class="left">
        <div class="steps__wrapper">
            <div class="step-icon">
                <span style="">1</span>
            </div>
            <div class="step-container">
                <div class="header">
                    <span class="step-text">Skopuj kod piksela konwersji oraz dodaj nas do swojej polityki prywatności.</span>
                </div>
            </div>
        </div>
        <pixel-pixel-code/>
    </div>
    <div class="right">
        <div class="steps__wrapper">
            <div class="step-icon">
                <span style="">2</span>
            </div>
            <div class="step-container">
                <div class="header">
                    <span class="step-text">Umieść kod piksela na swojej witrynie</span>
                </div>
                <div class="content">
                    <span class="content-text">Gdzie umieścić skrypt?</span>
                    <ul>
                        <li class="content-text"><div [outerText]="'pomiędzy tagami <head> i </head>, '"></div></li>
                        <li class="content-text">na stronie potwierdzającej złożenie zamówienia w sklepie (ostatnia strona procesu składania zamówienia w obrębie jednej sesji przeglądarki),</li>
                        <li class="content-text">na stronie informującej o wysłaniu wiadomości email - w przypadku sklepów, które wymagają potwierdzenia zamówienia przez email.</li>
                    </ul>
                    <a
                        mat-flat-button
                        target="_blank"
                        color="primary"
                        class="button-alternative"
                        href="https://pomoc.onetads.pl/docs/wprowadzenie"
                    >
                        Instrukcja instalacji skryptu Piksela Konwersji
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
